
import {defineComponent} from 'vue'
import BaseOffcanvasButtonClose from '@/components/UI/Bootstrap/Offcanvas/BaseOffcanvasButtonClose.vue'
import {FormMixin} from '@/components/base/FormMixin'
import GenericFormWrapper from '@/components/base/GenericFormWrapper.vue'
import InputText from '@/components/UI/InputText.vue'
import InputCodeEditor from "@/components/UI/InputCodeEditor.vue";
import {TextWithTitleContentRestDto} from "@/api/pharma-cms-content-block/models";
import {TextWithTitleContentRestDtoModel} from "@/models/api/pharma-cms-content-block/TextWithTitleContentRestDtoModel";
import {NormalContentBlockRestService} from "@/services/rest/cms-content-block/NormalContentBlockRestService";
import {AuthContext} from "@/context/AuthContext";

export default defineComponent({
  name: 'CustomCssPreviewContentBlocksDetail',
  mixins: [FormMixin],
  components: {InputCodeEditor, BaseOffcanvasButtonClose, GenericFormWrapper, InputText },
  emits: ['updated'],
  props: {
    contentBlockId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      contentBlock: TextWithTitleContentRestDtoModel.createWithDefaults() as TextWithTitleContentRestDto,
      contentBlockType: 'CUSTOM_CSS_PREVIEW'
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async doInitialize(): Promise<void> {
      // Do nothing
    },
    async doReload(): Promise<void> {
      this.contentBlock = await NormalContentBlockRestService.getInstance().getNormalContentBlockTextWithTitle(this.contentBlockType, this.contentBlockId);
      if (!this.contentBlock.content!.nl) {
        this.contentBlock.content!.nl = '';
      }
    },
    async doSubmit(): Promise<void> {
      await NormalContentBlockRestService.getInstance().updateNormalContentBlockTextWithTitle(this.contentBlock, this.contentBlockType, this.contentBlockId);
    },
    async afterSave(): Promise<void> {
      this.$emit('updated');
    },
    hasAuthorization(): boolean {
      return AuthContext.isDpUser();
    }
  }
})
